import { Check } from "lucide-react";
import { teamById } from "@/components/game/InitialDot";
import { MascotPicker } from "@/components/game/Mascot";

export const StudentLobby = ({ state, send }) => {
  const me = state.me;
  const myTeam = teamById(state.teams, me.team_id);
  const choosing = state.settings.team_selection === "student" && !state.solo;
  return (
    <div className="space-y-6" data-testid="student-lobby">
      <div>
        <p className="eyebrow">Lobi</p>
        <h2 className="font-display text-3xl font-black mt-1">Oyunun başlaması bekleniyor</h2>
      </div>
      {choosing ? (
        <div className="space-y-3">
          <p className="text-slate-300">Masanı seç:</p>
          {state.teams.map((t) => {
            const mine = t.id === me.team_id;
            const ok = state.can_choose?.[t.id];
            return (
              <button key={t.id} disabled={!ok && !mine} onClick={() => send({ type: "choose_team", team_id: t.id })}
                data-testid={`choose-team-${t.id}`}
                className={`w-full flex items-center gap-3 rounded-xl border-2 p-4 text-left transition-colors duration-150 ${mine ? "bg-white/10" : "bg-white/5"} backdrop-blur-md hover:scale-[1.02] transition-[transform,box-shadow,background-color] disabled:opacity-40 disabled:hover:scale-100`}
                style={{ borderColor: mine ? t.color : "rgba(71,85,105,0.5)", boxShadow: mine ? `0 0 22px ${t.color}66` : "none" }}>
                <span className="h-5 w-5 rounded-full" style={{ backgroundColor: t.color }} />
                <span className="font-display text-xl font-bold flex-1">{t.name}</span>
                <span className="text-slate-400">{t.count}/{state.settings.seats_per_team}</span>
                {mine && <Check className="h-6 w-6" style={{ color: t.color }} />}
              </button>
            );
          })}
        </div>
      ) : (
        <div className="panel p-5" data-testid="student-team-info">
          {state.solo ? <p className="text-xl" data-testid="student-solo-info">Bireysel oyun: <b className="text-[#FACC15]">kendi puanın için</b> yarışıyorsun!</p>
            : myTeam ? <p className="text-xl">Masan: <b style={{ color: myTeam.color }}>{myTeam.name}</b></p>
            : <p className="text-slate-300">Öğretmenin seni bir masaya yerleştirecek.</p>}
        </div>
      )}
      <MascotPicker value={me.mascot} onPick={(m) => send({ type: "choose_mascot", mascot: m })} />
    </div>
  );
};
